import { put, takeEvery, takeLatest } from 'redux-saga/effects'

import call from '../call'
import { delay, setAegisOpt, lsSetItem } from '@/utils/util'
import { SSO_ATTEMPTED_KEY, SSO_SESSION_EXPIRED_KEY } from '@/utils/sso'
import { APP, LOADING } from '../actionTypes'
import {
  userInfo,
  userResources,
  entityIcon,
  updateEntityConfigInfo,
  updateUIConfig,
} from '../reducers/app'
import { loadingSuccess } from '../reducers/loading'

import {
  getUserInfoService,
  getUserResourcesService,
  logoutService,
  getEntityIconService,
  getEntityBrandListService,
  getUIConfigService,
} from '../service/app'

function* getUserInfo(action: Action) {
  const res: ResponseData = yield call(getUserInfoService, action)
  if (res && res?.code === 0) {
    setAegisOpt({ uin: res.data.userAccount + '/' + res.data.userName })
    yield put(userInfo(res.data))
  }
}

function* getEntityIcon(action: Action) {
  const res: ResponseData = yield call(getEntityIconService, action)
  if (res && res?.code === 0) {
    yield put(entityIcon(res.data))
  }
}

function* getUserResources(action: Action) {
  const res: ResponseData = yield call(getUserResourcesService, action, {
    type: LOADING.RESOURCE,
  })
  if (res && res.code === 0 && res.data) {
    yield put(userResources(res.data))
  }
  yield put(loadingSuccess({ type: LOADING.RESOURCE, success: res.code === 0 }))
}

function* logout(action: Action) {
  const res: ResponseData = yield call(logoutService, action)
  if (res && res.code === 0) {
    const target = location.hash.slice(1) || `${location.pathname}${location.search}`
    sessionStorage.removeItem(SSO_ATTEMPTED_KEY)
    sessionStorage.removeItem(SSO_SESSION_EXPIRED_KEY)
    yield put(userInfo({ isLogout: true }))
    yield lsSetItem('__fallBack__', location.href)
    // loggedOut 标记用于区分"主动登出"与"会话过期"：SSO 实体的登录页据此展示"已退出"提示页，
    // 而不是立即自动发起 SSO 授权（否则会被三方 IdP 的存活会话静默拉回，登出形同虚设）。
    // 未开启 SSO 的实体不受影响：登录页会忽略该参数，正常展示账号/验证码登录表单。
    location.hash = `/login?target=${encodeURIComponent(target)}&loggedOut=1`
    yield delay(200)
    yield put(userInfo({}))
    yield put(userResources([]))
  }
}

function* getEntityBrandList(action: Action) {
  const res: ResponseData = yield call(getEntityBrandListService, action)
  if (res?.code === 0 && res.data) {
    yield put(updateEntityConfigInfo({ brandList: res.data }))
  }
}

function* getUIConfig(action: Action) {
  const res: ResponseData = yield call(getUIConfigService, action)
  if (res.code === 0 && res.data) {
    const {
      menuBarLayout,
      sidebarColor,
      chartLayout,
      subjectColor,
      mapBackgroundColor,
      loginPagePicture,
      loginPageLayout,
      loginPageColor,
      loginPageTitle,
      loginPageSubTitle,
      resourceLayOutMap,
    } = res.data
    yield put(
      updateUIConfig({
        menuBarLayout: menuBarLayout || 1,
        sidebarColor: sidebarColor || 'white',
        chartLayout: chartLayout || 1,
        subjectColor: subjectColor || 'black',
        mapBackgroundColor: mapBackgroundColor || 'black',
        loginPagePicture: loginPagePicture || null,
        loginPageLayout: loginPageLayout || 'columnRight',
        loginPageColor: loginPageColor || 'black',
        loginPageTitle: loginPageTitle || '骑行智能监管平台',
        loginPageSubTitle: loginPageSubTitle || '两轮车数字化治理平台',
        resourceLayOutMap: resourceLayOutMap || null,
      })
    )
  }
}

export default function* root() {
  yield takeEvery(APP.GET_USER_INFO, getUserInfo)
  yield takeEvery(APP.GET_ENTITY_ICON, getEntityIcon)
  yield takeLatest(APP.GET_USER_RESOURCES, getUserResources)
  yield takeLatest(APP.GET_ENTITY_BRANDLIST, getEntityBrandList)
  yield takeEvery(APP.LOG_OUT, logout)
  yield takeEvery(APP.GET_UI_CONFIG, getUIConfig)
}
